module.exports = __webpack_public_path__ + "static/media/docudesign.b907d1f2.png";